module.exports = __webpack_public_path__ + "static/media/nurse_accredited4.8dbdc760.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nurse_accredited4.png
// module id = 483
// module chunks = 0